module.exports = __webpack_public_path__ + "static/img/Volar.07d35a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/Volar.jpg
// module id = d7Cm
// module chunks = 1